import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import MyTypography from "@saleor/components/MyTypography";
import PageHeader from "@saleor/components/PageHeader";
import { usePoUploadCustomerSettingsQuery } from "@saleor/graphql";
import useNavigator from "@saleor/hooks/useNavigator";
import { sectionNames } from "@saleor/intl";
import React, { FC } from "react";
import { useIntl } from "react-intl";

import POSettingsTable from "../components/POSettingsTable";
import { poUploadUrl } from "../urls";

const POUploadSettingsView: FC = () => {
  const intl = useIntl();
  const navigate = useNavigator();
  const handleBack = () => {
    navigate(poUploadUrl);
  };

  const { data, refetch } = usePoUploadCustomerSettingsQuery({
    variables: { first: 100 }
  });

  return (
    <Container>
      <PageHeader title={intl.formatMessage(sectionNames.poUploadSettings)} />
      <AppHeader onBack={handleBack}>
        <MyTypography variant="body3">
          {intl.formatMessage({ defaultMessage: "กลับไป" })}
        </MyTypography>
      </AppHeader>
      <POSettingsTable data={data} refetch={refetch} />
    </Container>
  );
};

export default POUploadSettingsView;
